import { render, staticRenderFns } from "./GlobalErrorOverlay.vue?vue&type=template&id=b59829f2&scoped=true"
import script from "./GlobalErrorOverlay.vue?vue&type=script&lang=js"
export * from "./GlobalErrorOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59829f2",
  null
  
)

export default component.exports